import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserCardState } from "../../interface/interface";

type Props = {
  data: UserCardState;
  LeaderInsert: (usr_id: string) => void;
  LeaderDelete: (usr_id: string) => void;
};

const LeaderCard = ({ data, LeaderInsert, LeaderDelete }: Props) => {
  const navigate = useNavigate();
  const [isInsert, setIsInsert] = useState(false);
  useEffect(() => {
    if (data.usr_typ === "READ") {
      setIsInsert(true);
    } else {
      setIsInsert(false);
    }

    return () => {};
  }, [data]);

  return (
    <div className="leader-card">
      <div className="number">{data.usr_id}</div>
      <div className="id">{data.login_id}</div>
      <div className="email">{data.usr_email}</div>
      <div className="nickname">{data.login_nm}</div>
      <div className="project">{data.cnt_prjt_open}회</div>
      <button
        className="detail"
        onClick={() => {
          navigate(`/user/detail`, { state: data });
        }}
      >
        상세보기
      </button>
      <button
        className={`insert ${isInsert ? "insert-blue" : ""}`}
        onClick={() => {
          if (isInsert) {
            LeaderDelete(data.usr_id);
          } else {
            LeaderInsert(data.usr_id);
          }
          setIsInsert(!isInsert);
        }}
      >
        <div className="circle" />
      </button>
    </div>
  );
};

export default LeaderCard;
